module.exports = __webpack_public_path__ + "static/media/George H. W. Bush - 1988.c2bd4cc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/George H. W. Bush - 1988.jpg
// module id = 473
// module chunks = 0